/**
 * Video component (currently only YouTube is supported)
 */

import React from "react"
import { kebabCase } from "lodash"
import { FaPlay } from "react-icons/fa"
import "../styles/video.css"
import CopyLinkButton from "./copy-link-button"

const Video = ({ props }) => {
  const videoUrlRegEx =
    /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/

  return (
    <section
      className="section container m-section max-w-7xl"
      key={props.heading || props.videoLink}
    >
      <div className="group-copy-link group">
        {props.heading ? (
          <>
            <h2
              id={kebabCase(props.heading).replace(/[0-9]/g, "")}
              className="anchor-heading text-center mb-10"
              data-sal="slide-up"
              data-sal-delay="300"
            >
              {props.heading}
            </h2>
            <CopyLinkButton heading={props.heading} />
          </>
        ) : null}
      </div>
      {props.videoLink ? (
        <>
          <div
            className="video-container print:hidden"
            data-sal="slide-down"
            data-sal-delay="300"
          >
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              className="video-iframe"
              src={
                props.videoLink.match(videoUrlRegEx) && !props.videoLink.includes("videoseries")
                  ? `https://www.youtube-nocookie.com/embed/${props.videoLink.match(videoUrlRegEx)[1]
                  }`
                  : props.videoLink
              }
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              title={props.heading || "Video"}
            ></iframe>
          </div>
          <div className="hidden print:block">
            <a
              href={props.videoLink}
              target="_blank"
              rel="noreferrer"
              className="flex"
            >
              <span className="text-3xl mr-2">
                <FaPlay />
              </span>
              Watch {props.heading} on YouTube
            </a>
          </div>
        </>
      ) : null}
    </section>
  )
}

export default Video
